import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type ValidateDeclarationModel = {
  id: string | number
}

export const fetchValidateDeclaration = ({ id }: ValidateDeclarationModel) => {
  return new PsychologicalDocumentsUseCase(
    `/declaracao/modal/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveValidateDeclaration = ({ id }: ValidateDeclarationModel) => {
  return new PsychologicalDocumentsUseCase(
    `/declaracao/modal/save/${id}`,
    makeAxiosHttpClient()
  )
}
